import { categoriesForCodepoint } from './unicode_blocks.js'

export function codepointHex(codepoint) {
  return codepoint.toString(16).toUpperCase().padStart(4, '0')
}

export function buildCategoryBadgesHtml(codepoint, escapeHtml) {
  const categories = categoriesForCodepoint(codepoint)
  if (!categories.length) return ''

  const badges = categories
    .map((category) => {
      const icon = category.icon ? `<span class="char-category-icon" aria-hidden="true">${escapeHtml(category.icon)}</span>` : ''
      const label = escapeHtml(category.label)
      return `<button type="button" class="inline-flex items-center gap-1.5 text-xs px-2 py-0.5 rounded bg-slate-100 text-emerald-700 hover:bg-emerald-50 hover:text-emerald-900 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/50" data-block-id="${escapeHtml(category.id)}" data-characters-category-badge="true" aria-label="View ${label} characters" title="View ${label}">${icon}<span>${label}</span></button>`
    })
    .join('')

  return `
    <div>
      <p class="text-sm font-medium text-slate-900 mb-1.5">Categories</p>
      <div class="flex flex-wrap gap-1.5" aria-label="Character categories">
        ${badges}
      </div>
    </div>
  `
}

export function buildCodepointFieldsHtml(codepoint, escapeHtml) {
  const hex = codepointHex(codepoint)

  return `
    <dl class="text-sm space-y-3">
      <div>
        <dt class="font-medium text-slate-900">Unicode: <span class="font-mono text-slate-800">U+${hex}</span></dt>
   
      </div>
      <div>
        <dt class="font-medium text-slate-900">CHAR Number: <span class="mt-1 font-mono text-slate-800">${escapeHtml(String(codepoint))}</span></dt>
   
      </div>
    </dl>
  `
}
